import { Component } from '@angular/core';

/** Catálogo de relatórios com endpoint próprio na API (não confundir com o espelho financeiro). */
export interface FinancialReportCatalogItem {
  id: string;
  title: string;
  description: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-financial-reports',
  templateUrl: './financial-reports.component.html',
  styleUrls: ['./financial-reports.component.css']
})
export class FinancialReportsComponent {
  readonly reports: FinancialReportCatalogItem[] = [
    {
      id: 'ap-position-summary',
      title: 'Posição de contas a pagar',
      description:
        'KPIs de aging, pendências, vencidos e pagamentos no período. Consome o endpoint dedicado de posição CP.',
      route: '/financial/reports/ap-position',
      icon: 'fas fa-file-invoice-dollar'
    }
  ];
}
